import { useState } from 'react';
import { IconUp, IconDown } from '@ui/src';

import cn from '../styles.module.css';

const AdditionalInfoWrapper = ({ children }: { children: React.ReactNode }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={cn.additionalInfoWrapper}>
      <button
        type="button"
        className={cn.additionalInfoWrapperButton}
        onClick={() => setCollapsed(!collapsed)}
      >
        Additional Information
        <div className={cn.additionalInfoWrapperButtonIcon}>
          {collapsed ? <IconUp /> : <IconDown />}
        </div>
      </button>
      {!collapsed && <div className={cn.additionalInfoContent}>{children}</div>}
    </div>
  );
};

export default AdditionalInfoWrapper;
